<template>
  <svg width="100%" height="100%" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M15.6813 18.5605L9.56445 12.5605L15.6813 6.56055"
      stroke="currentColor"
      stroke-width="1.17707"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
